import React from 'react';
import { Modal, Popconfirm, Button, Table, Select, DatePicker, Icon, message } from 'antd';
import moment from 'moment';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';

const { Option } = Select;

class Instruction extends React.Component {
    state = {
        visible: false,
        confirmLoading: false,
        dateFormat: "YYYY-MM-DD",
    }
    
    show = (record, heredityId) => {
        if (record == undefined) {
            this.setState({
                type: 'add',
                hospitalId: '',
                showHospitalList: [],
                params: { heredityId },
                visible: true,
            });
        } else {
            this.setState({
                type: 'edit',
                params: { heredityId, ...record },
                visible: true,
            }, () => {
                this.getHeredityDeclareList();
            });
        }
    };

    close = () => {
        this.setState({ visible: false });
    };

    confirm = () => {
        let url;
        const { reload } = this.props;
        const { type, params = {}, showHospitalList } = this.state;
        const { declareProgressId = '', heredityApproveDate = null } = params;
        
        if (type == 'add') {
            if (showHospitalList.length <= 0) {
                message.error('请添加医院单位');
                return;
            } else if (showHospitalList.length > 0) {
                showHospitalList.map((item, index) => {
                    params[`ids[${index}]`] = item.hospitalId;
                });
                if (declareProgressId == '') {
                    message.error('请选择申报进展');
                    return;
                } else if (declareProgressId == '15') {
                    if (heredityApproveDate == null) {
                        message.error('请选择遗传办批准日期');
                        return;
                    }
                } else if (declareProgressId != '15') {
                    params.heredityApproveDate = null;
                }
            }
            url = API_URL.invStartUp.saveHeredityPetition;
        } else if (type == 'edit') {
            if (declareProgressId == '') {
                message.error('请选择申报进展');
                return;
            } else if (declareProgressId == '15') {
                if (heredityApproveDate == null) {
                    message.error('请选择遗传办批准日期');
                    return;
                }
            } else if (declareProgressId != '15') {
                params.heredityApproveDate = null;
            }
            url = API_URL.invStartUp.updateHeredityPetition;
        }
        
        this.setState({ confirmLoading: true });

        const options = {
            method: 'POST',
            url,
            data: { ...params },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.success);
                    this.setState({ visible: false });
                    reload();
                } else {
                    message.error(res.error);
                }
                this.setState({ confirmLoading: false });
            }),
            errorResult: (res => {
                this.setState({ confirmLoading: false });
            }),
        };
        $.sendRequest(options);
    }

    getPetitionHospitalList = () => {
        const { heredityId } = this.state.params;
        const options = {
            url: API_URL.invStartUp.queryPetitionHospitalList,
            data: { heredityId },
            dataType: 'json',
            doneResult: (res => {
                this.setState({ hospitalList: res.hospitals });
            }),
        };
        $.sendRequest(options);
    }

    getHeredityDeclareList = () => {
        const { type, params } = this.state;
        const data = { progressType: 'PETITION' };
        if (type == 'edit') {
            data.orders = params.orders;
        }
        const options = {
            url: API_URL.invStartUp.queryHeredityDeclareProgressList,
            data,
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    this.setState({ heredityDeclareList: res.heredityDeclareProgress});
                } else {
                    message.error(res.error);
                }
            }),
        };
        $.sendRequest(options);
    }

    handleHospitalSelectChange = (value) => {
        this.setState({ hospitalId: value });
    }

    handleAdd = () => {
        const { hospitalList = [], showHospitalList, hospitalId } = this.state;
 
        if (hospitalId == '') {
            message.warning('请添加医院单位');
            return;
        } else {
            const value = hospitalList.filter(item => item.hospitalId == hospitalId);
            if (value.length > 0) {
                const hasSameValue = showHospitalList.some(item => item.hospitalId == value[0].hospitalId);
                hasSameValue ? message.warning('医院单位不能重复添加') : showHospitalList.push(value[0]);
            }
        }
        this.setState({
            hospitalId: '',
            showHospitalList,
        });
    }

    handleRemove = (e, index) => {
        const { showHospitalList } = this.state;
        showHospitalList.splice(index, 1);
        this.setState({ showHospitalList });
    }

    getList = () => {
        const { showHospitalList } = this.state;
        if (showHospitalList.length > 0) {
            return (
                <ul className="right-list">
                    {
                        showHospitalList.map((item, index) => (
                            <li className="right-item" key={item.hospitalId}>
                                <span title={item.hospitalName}>{item.hospitalName}</span>
                                <Icon type="close-circle" className="icon" onClick={e => this.handleRemove(e, index)}/>
                            </li>
                        ))
                    }
                </ul>
            )
        }
    }

    getNodeList = (string) => {
        const list = string.split(',');
        let data;
        if (list.length > 0) {
            data = list.map(item => <span>{item}<br/></span>);
        }
        return data;
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    handleDateChange = (value, key) => {
        const { dateFormat, params } = this.state;
        let time = null;
        if(value){
            time = value.format(dateFormat);
        }
        params[key] = time;
        this.setState({ params });
    }

    render () {
        const {
            visible,
            confirmLoading,
            dateFormat,
            type,
            params = {},
            hospitalId,
            hospitalList = [],
            heredityDeclareList = []
        } = this.state;
        const { declareProgressId = '', hospitalName = '', heredityApproveDate = null } = params;
        const hospitalOptions = hospitalList.map(item => <Option key={item.hospitalId} value={item.hospitalId}>{item.hospitalName}</Option>);
        const heredityDeclareOptions = heredityDeclareList.map(item => <Option key={item.heredityDeclareProgressId} value={item.heredityDeclareProgressId}>{item.declareProgressName}</Option>);
        const ApproveDate = heredityApproveDate !== null ? moment(heredityApproveDate, dateFormat) : null;
        return (
            <Modal
                title={type == 'add' ? "添加小批件" : "修改小批件"}
                visible={visible}
                onCancel={this.close}
                onOk={this.confirm}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="460px"
                confirmLoading={confirmLoading}
            >
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left">
                                <span style={{color: 'red'}}>*</span>医院单位:
                            </div>
                            {
                                type == 'add'
                                ?
                                <div className="item-right">
                                    <Select
                                        style={{width: 180}}
                                        value={hospitalId}
                                        onFocus={this.getPetitionHospitalList}
                                        onChange={this.handleHospitalSelectChange}
                                        allowClear={true}
                                    >
                                        { hospitalOptions }
                                    </Select>
                                    <Icon
                                        type="plus-circle-o"
                                        onClick={this.handleAdd}
                                        style={{marginLeft: 10, fontSize: 16, verticalAlign: 'middle', cursor: 'pointer'}}
                                    />
                                    { this.getList() }
                                </div>
                                :
                                <div className="item-right">
                                    { hospitalName && this.getNodeList(hospitalName) }
                                </div>
                            }
                        </li>
                        <li className="modal-item">
                            <div className="item-left">
                                <span style={{color: 'red'}}>*</span>申报进展:
                            </div>
                            <div className="item-right">
                                <Select
                                    style={{width: 180}}
                                    value={declareProgressId}
                                    onFocus={this.getHeredityDeclareList}
                                    onChange={value => this.handleSelectChange(value, 'declareProgressId')}
                                    allowClear={true}
                                >
                                    {heredityDeclareOptions}
                                </Select>
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left">
                                { declareProgressId == '15' && <span style={{color: 'red'}}>*</span>}
                                遗传办批准日期:
                            </div>
                            {
                                declareProgressId == '15' && 
                                <div className="item-right">
                                    <DatePicker
                                        style={{width: 180}}
                                        format={dateFormat}
                                        placeholder="请选择"
                                        value={ApproveDate}
                                        onChange={(e) => this.handleDateChange(e, "heredityApproveDate")}
                                    />
                                </div>
                            }
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

class InstructionModal extends React.Component {
    state = {
        visible: false,
        loading: false,
    }
    
    show = (heredityId, editable) => {
        this.editable = editable;
        this.setState({
            data: [],
            heredityId,
            visible: true,
            pagination: {
                current: 1,
                pageSize: 10,
            }
        }, () => {
            this.loadData();
        });
    };

    close = () => {
        this.setState({ visible: false });
    };

    loadData = () => {
        const { heredityId, pagination } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url: API_URL.invStartUp.queryHeredityPetitionList,
            data: {
                heredityId,
                limit: pagination.pageSize,
                offset: pagination.current,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    pagination.total = res.totalCount;
                    this.setState({
                        pagination,
                        loading: false,
                        data: res.datas,
                    });
                } else {
                    message.error(res.error);
                }
            }
        }
        $.sendRequest(options);
    }

    delete = (heredityPetitionId) => {
        const options = {
            method: 'post',
            url: API_URL.invStartUp.deleteHeredityPetition,
            data: { heredityPetitionId },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    message.success(res.success);
                    this.loadData();
                } else {
                    message.error(res.error);
                }
            }
        }
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '次数序号',
        dataIndex: 'index',
        key: 'index',
        width: 85,
    }, {
        title: '医院名单',
        dataIndex: 'hospitalName',
        key: 'hospitalName',
        width: 150,
    }, {
        title: '申报进展',
        dataIndex: 'declareProgressName',
        key: 'declareProgressName',
        width: 130,
    }, {
        title: '遗传办批准日期',
        dataIndex: 'heredityApproveDate',
        key: 'heredityApproveDate',
        width: 100,
    }, {
        title: '操作',
        width: 90,
        render: (text, record) => {
            const { heredityPetitionId } = record;

            return (
                <span>
                    <a onClick={() => this.props.canEditByInvStatus(() => this.showInstruction(record))}>修改</a>
                    <span className="ant-divider" />
                    <Popconfirm title={'确定要删除吗?'} onConfirm={() => this.props.canEditByInvStatus(() => this.delete(heredityPetitionId))} okText="确定" cancelText="取消">
                        <a >删除</a>
                    </Popconfirm>
                </span>
            );
        },
    }]

    getDateSource = () => {
        const { data = [], pagination } = this.state;
        const dataSource = [];

        data.map((item, index) => {
            dataSource.push({
                index: `第${(pagination.current - 1) * 10 + index + 1}次`,
                ...item,
                heredityApproveDate: item.heredityApproveDate && item.heredityApproveDate.slice(0, 10),
            })
        });

        return dataSource;
    }

    handleTableChange = (pagination) => {
        const pager = { ...this.state.pagination };
        if (pager.current == pagination.current){
            pager.current = 1;
        } else {
            pager.current = pagination.current;
        }
        this.setState({
            pagination: pager,
        }, () => {
            this.loadData();
        });
    }

    showInstruction = (record) => {
        const { heredityId } = this.state;
        this.InstructionRef.show(record, heredityId);
    }

    render () {
        const { visible, loading, pagination } = this.state;
        const columns = this.getColumns();
        !this.editable && columns.pop();
        return (
            <Modal
                title="小批件"
                visible={visible}
                onCancel={this.close}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="652px"
                footer={<Button key="close" type="primary" onClick={this.close}>关 闭</Button>}
            >
                <div className="cont-cont contract-record" style={{padding: '0 40px 20px'}}>
                    <ul className="preview-list">
                        <li className="item preview-item" style={{background: '#fff', paddingRight: 0}}>
                            <span style={{float: 'right'}}>
                                {
                                    this.editable &&
                                    <Button type="primary" onClick={() => this.props.canEditByInvStatus(() => this.showInstruction())}>添加</Button>
                                }
                            </span>
                        </li>
                    </ul>
                    <Table
                        loading={loading}
                        columns={columns}
                        dataSource={this.getDateSource()}
                        rowKey={record => record.index}
                        onChange={this.handleTableChange}
                        pagination={pagination}
                        scroll={{x: 555}}
                    />
                    <Instruction ref={el => this.InstructionRef = el} reload={this.loadData} />
                </div>
            </Modal>
        );
    }
}

export default InstructionModal;


// WEBPACK FOOTER //
// ./src/components/invStartUp/heredity/InstructionModal.js